module.exports = __webpack_public_path__ + "img/pt.90f76f1.webp";